// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing-page-mobile-banner-container {
  background: linear-gradient(to bottom, #e7985e, #fae2a6);
}
`, "",{"version":3,"sources":["webpack://./src/pages/landingPage/banner/mobileBanner/style.css"],"names":[],"mappings":"AAAA;EACE,wDAAwD;AAC1D","sourcesContent":[".landing-page-mobile-banner-container {\n  background: linear-gradient(to bottom, #e7985e, #fae2a6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
